import React from 'react';
import MarkdownModal from '../common/MarkdownModal';

interface SubscribeModalProps {
  open: boolean;
  onClose: () => void;
}

const SubscribeModal: React.FC<SubscribeModalProps> = ({ open, onClose }) => {
  return (
    <MarkdownModal
      open={open}
      onClose={onClose}
      title=""
      markdownKey="SUBSCRIBE_CALENDAR_GUIDE" 
    />
  );
};

export default SubscribeModal;